export const isEmbed = window.document.referrer.includes('swarm.com')

export enum NetworkId {
  Ethereum = 1,
  Polygon = 137,
  Base = 8453,
  ArbitrumSepolia = 421614,
}

export const whitelabeledTokens: Record<NetworkId, string[]> = {
  [NetworkId.Polygon]: [
    '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
    '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89',
  ],
  [NetworkId.ArbitrumSepolia]: [
    '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
    '0x862ead81f034bfe80fc8d35b7496ba9d5bf9d044',
  ],
  [NetworkId.Ethereum]: [],
  [NetworkId.Base]: [],
}
